// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'w3-css/w3.css';
import VueResource from 'vue-resource'
Vue.use(VueResource)
import App from './App'
import router from './router'
import firebase from 'firebase'
Vue.config.productionTip = false
import store from './store/store'
import { mapGetters, mapActions } from 'vuex'
import { AppConfig } from './services'
import { sync } from 'vuex-router-sync'
import VueAnalytics from 'vue-analytics'
const unsync = sync(store, router)
import moment from 'moment'
import 'font-awesome/css/font-awesome.css' 

import VueQrcodeReader from 'vue-qrcode-reader'
Vue.use(VueQrcodeReader)

//import components globaly

import ImageEditor from './components/shared/ImageEditor'
import RatingSelector from './components/shared/RatingSelector'
import PageNotesEditor from './components/shared/PageNotesEditor'




import FavSelection from './components/shared/FavSelection'
import StatusSelector from './components/shared/StatusSelector'
import QuantitySelector from './components/shared/QuantitySelector'

import BusinessDialog from './components/shared/BusinessDialog'
import RemedialDialog from './components/shared/RemedialDialog'

import BusinessesLinksDialog from './components/shared/BusinessesLinksDialog'
import BusinessesLinksList from './components/shared/BusinessesLinksList'

import AddNoteDialog from './components/shared/controls/AddNoteDialog'
import ImageDialog from './components/shared/controls/ImageDialog'

import CancelDialogButton from './components/shared/controls/buttons/CancelDialogButton'
import BackButton from './components/shared/controls/buttons/BackButton'
import CancelButton from './components/shared/controls/buttons/CancelButton'
import RefreshButton from './components/shared/controls/buttons/RefreshButton'
import SaveButton from './components/shared/controls/buttons/SaveButton'
import AddButton from './components/shared/controls/buttons/AddButton'
import AddCartButton from './components/shared/controls/buttons/AddCartButton'
import BuyNowButton from './components/shared/controls/buttons/BuyNowButton'
import TabLinkButton from './components/shared/controls/buttons/TabLinkButton'
import CloneButton from './components/shared/controls/buttons/CloneButton'
import SetLocationButton from './components/shared/controls/buttons/SetLocationButton'
import OpenClose from './components/shared/controls/OpenClose'
import Installers from './components/shared/controls/Installers'


import NewButton from './components/shared/controls/buttons/NewButton'
import DeleteButton from './components/shared/controls/buttons/DeleteButton'
import UpdateButton from './components/shared/controls/buttons/UpdateButton'
import OpenGoogleMaps from './components/shared/controls/buttons/OpenGoogleMaps'


import LargeButton from './components/shared/controls/buttons/LargeButton'
import LargeButtonWide from './components/shared/controls/buttons/LargeButtonWide'
import ConfirmDialog from './components/shared/controls/ConfirmDialog'
import HelpDialog from './components/shared/controls/HelpDialog'
import CommonPageLayout from './components/shared/controls/layouts/CommonPageLayout'
import ULLayout from './components/shared/controls/layouts/ULLayout'
import BusinessInfoLayout from './components/shared/controls/layouts/BusinessInfoLayout'
import BusinessInfoLayoutItem from './components/shared/controls/layouts/BusinessInfoLayoutItem'

import DialogLayout from './components/shared/controls/layouts/DialogLayout'

import TabLinkLayout from './components/shared/controls/layouts/TabLinkLayout'
import RemedialsTableLayout from './components/shared/controls/layouts/RemedialsTableLayout'
import RemedialTabsLayout from './components/shared/controls/layouts/RemedialTabsLayout'
import RemedialLayout from './components/shared/controls/layouts/RemedialLayout'
import RemedialNewLayout from './components/shared/controls/layouts/RemedialNewLayout'

import TabLayout from './components/shared/controls/layouts/TabLayout'


import BusinessesLayout from './components/shared/controls/layouts/BusinessesLayout'

Vue.component('pagenotes-editor', PageNotesEditor)
Vue.component('image-editor',ImageEditor)
Vue.component('rating-selector',RatingSelector)
Vue.component('fav-selector',FavSelection)
Vue.component('status-selector',StatusSelector)
Vue.component('quantity-selector',QuantitySelector)
Vue.component('remedial-tabs-layout',RemedialTabsLayout)
Vue.component('remedial-layout',RemedialLayout)
Vue.component('remedial-new-layout',RemedialNewLayout)

Vue.component('help-dialog',HelpDialog)
Vue.component('business-dialog',BusinessDialog)

Vue.component('remedial-dialog',RemedialDialog)
Vue.component('businesses-links-dialog',BusinessesLinksDialog)
Vue.component('businesses-links-list',BusinessesLinksList)

Vue.component('add-note-dialog',AddNoteDialog)
Vue.component('image-dialog',ImageDialog)

Vue.component('cancel-dialog-button',CancelDialogButton)
Vue.component('back-button',BackButton)
Vue.component('cancel-button',CancelButton)
Vue.component('refresh-button',RefreshButton)

Vue.component('save-button',SaveButton)
Vue.component('update-button',UpdateButton)
Vue.component('open-gooogle-maps',OpenGoogleMaps)
Vue.component('set-location-button',SetLocationButton)
Vue.component('open-close',OpenClose)
Vue.component('installers-group',Installers)


Vue.component('add-button',AddButton)
Vue.component('add-cart-button',AddCartButton)
Vue.component('buy-now-button',BuyNowButton)
Vue.component('tab-link-button',TabLinkButton)

Vue.component('delete-button',DeleteButton)
Vue.component('clone-button',CloneButton)

Vue.component('new-button',NewButton)
Vue.component('large-button',LargeButton)
Vue.component('large-button-wide',LargeButtonWide)
Vue.component('confirm-dialog',ConfirmDialog)

//layouts
Vue.component('common-page-layout',CommonPageLayout)
Vue.component('business-info-layout',BusinessInfoLayout)
Vue.component('businesses-layout',BusinessesLayout)
Vue.component('businesses-layout-item',BusinessInfoLayoutItem)

Vue.component('ul-layout',ULLayout)
Vue.component('dialog-layout',DialogLayout)

Vue.component('remedials-table-layout',RemedialsTableLayout)
Vue.component('tablink-layout',TabLinkLayout)
Vue.component('tab-layout',TabLayout)

import lodash from 'lodash'
import VueLodash from 'vue-lodash'

Vue.use(VueLodash, lodash)  //registers the use of _.

import VueToastr from '@deveodk/vue-toastr'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-full-width',//'toast-top-center',//'toast-bottom-left',
  defaultType: 'info',
  defaultTimeout: 3000,
  preventDuplicates:true,
  
})

Vue.use(VueAnalytics, {
  id: 'UA-121804857-1'
})

/* eslint-disable no-new */
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('currency', function (value) {
  if(value){
    if(value<0)
    {
      return '-$' + Math.abs(parseFloat(value)).toFixed(2);
    }
    else
      return '$' + parseFloat(value).toFixed(2);
  }
  else
  {
    return "$0"
  }
});


Vue.filter('statustype', function (status,type) {
  
  if(!status || status===undefined)
     return {colour:'',name:'To be Actioned'}[type]

  let s = Object.keys(status)[0]
  return status[s][type] 
  
  //     // return statuses && status && statuses[status]?statuses[status]:{}
})

Vue.filter('remedialtype', function (value) {
    switch (value) {
      case 'createdto':
        return 'Created for'    
      case 'createdby':
        return 'Created by'    
      case 'lodgedto':
        return 'Logged with'    
      case 'lodgedby':
        return 'Logged by'    
      default:
        'Unknown'
    }
})

Vue.filter('toUpperCase', function (value) {
  return value.toUpperCase();
})
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).calendar();//format('LLL')
  }
})

Vue.filter('locationdisplay', function (value) {
  if (value) {
    let n = Number(value)
    let symbol = "m"
    if(n>1000)
    {
      symbol = "km"
      n=n/1000
      n=n.toFixed(1)
    }
    else
    {
      n = n.toFixed(0)
    }
    
    return `${n}${symbol}`
  }  
})

new Vue({
  el: '#vue-app',
  // provide the store using the "store" option.
  // this will inject the store instance to all child components.
  store,
  router,
  template: '<App/>',
  components: { App },
  methods: mapActions(['setLocation','setfcmToken','setBusiness','setupUser','initiateDealsWatcher','initiateFIBIPublicDeals','setUpServiceWorker','setBannerMessage','setConfig','setBusinessReferences','setToastMessage','setNewVersionAvailable']),
  created: function () {

    // Vue.http.options.root = '/';
    firebase.initializeApp(process.env.FIREBASE_CONFIG) 

    //The state here is post mutation. 
    store.subscribe((action, state) => {     
      // console.log(action)
      
      // if (action.type === "setToastMessage" && state.toastmessage) {
      //   var tm = state.toastmessage;
      //   this.$toastr(tm.type, tm.message, tm.title)  
      // }

      switch (action.type) {
        case 'setHelp':
        case 'updateOrder':
        case 'clearOrder':
        case 'last10AccountTransactions':
        case 'setProfile':    
   
          ga('send', 'event', 'Mutation', action.type); 
          this.$ga.event({
            eventCategory: 'Mutation',
            eventAction: action.type          
          })

          break;
        case 'route/ROUTE_CHANGED':
          this.$ga.page({
            page: action.payload.to.name,
            title: action.payload.to.name,
            location: window.location.href
          })
          // ga('send', 'event', 'Mutation', action.type,action.payload.to.name); 
          break;
        default:
          break;
      }


    }) 
    
    this.setConfig(window.globals).then(()=>{
        this.setUpServiceWorker()
    }) 
    // if(window.globals.newversionfound)
    // {
    //     this.setNewVersionAvailable(true)
    // }
    // commit('setNewVersionAvailable',true)

    // console.log("about to run service worker")
    
    // console.log("after service worker")
      
    this.setBusiness(window.globals.id).then((business)=>{  
      // if(business.name === 'FIBI')      
      //     router.push('fibitiles')  //go to tiles                  
      // else      
      //     this.initiateFIBIPublicDeals()      
      
      this.setBusinessReferences(business.id)//we need the business before loading user details.

      //set up the application first before logging user in.
      firebase.auth().onAuthStateChanged((user) => {
        this.setupUser(user)
      })

    })     

  }
})

// During app/Vue teardown (e.g., you only use Vue.js in a portion of your app and you 
// navigate away from that portion and want to release/destroy Vue components/resources)
// unsync() // Unsyncs store from router



// WEBPACK FOOTER //
// ./src/main.js